import React from 'react'
import DatePicker from 'material-ui-legacy/DatePicker'
import Dialog from 'material-ui-legacy/Dialog'
import { Card, CardActions, CardText, CardTitle } from 'material-ui-legacy/Card'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'

import errors from '../../lib/errors.js'
import { formatDate, dateToUTC } from '../../lib/formats'
import { projectTypeReport } from '../../stores/csv_reports'
import ProjectTypeSelector from '../ProjectTypes/ProjectTypeSelector'
import SaveButton from '../UI/SaveButton'
import BackButton from '../UI/BackButton'
import CloseButton from '../UI/CloseButton'
import PageTitle from '../UI/PageTitle'
import ErrorDialog from '../UI/ErrorDialog'
import CircularLoader from '../UI/CircularLoader'
import SimpleSelect from '../UI/SimpleSelect'

class ReportsByProjectType extends React.PureComponent {
  constructor(props) {
    super(props)

    // Default dates
    const thisYear = new Date().getFullYear()
    const yearStart = new Date(`${thisYear}-01-01`)
    const yearEnd = new Date(`${thisYear}-12-31`)

    this.state = {
      projectTypeId: null,
      startDate: dateToUTC(yearStart),
      endDate: dateToUTC(yearEnd),
      quoteState: null,
      csvFilename: null,
      csvContents: null,
      loading: false,
      error: null,
      showDoneDialog: false
    }
  }

  _setProjectType = projectTypeId => this.setState({ projectTypeId })

  _setQuoteState = (ev, key, quoteState) => this.setState({ quoteState })

  _setStartDate = (ev, date) => this.setState({ startDate: date })

  _setEndDate = (ev, date) => this.setState({ endDate: date })

  _generate = () => {
    const { projectTypeId, startDate, endDate, quoteState } = this.state

    this.setState({ loading: true })
    projectTypeReport(projectTypeId, startDate, endDate, quoteState)
      .then(result => {
        this.setState({
          csvFilename: result.filename,
          csvContents: result.contents,
          showDoneDialog: true,
          loading: false
        })
      })
      .catch(error =>
        this.setState({ error: errors.unpack(error), loading: false })
      )
  }

  _closeErrorDialog = () => this.setState({ error: null })

  _closeDoneDialog = () =>
    this.setState({
      showDoneDialog: false,
      csvFilename: null,
      csvContents: null
    })

  render() {
    const {
      projectTypeId,
      startDate,
      endDate,
      quoteState,
      csvFilename,
      csvContents,
      loading,
      error,
      showDoneDialog
    } = this.state

    const enableGenerate = projectTypeId && quoteState && !loading
    const doneDialogActions = [
      <CloseButton onTouchTap={this._closeDoneDialog} />
    ]
    const quoteStateOptions = {
      Draft: 'draft',
      Pending: 'pending',
      Awarded: 'awarded',
      Actual: 'actual'
    }

    // Hack to download CSV automatically
    if (csvFilename && csvContents) {
      const blobURL = window.URL.createObjectURL(csvContents)
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'
      a.href = blobURL
      a.download = csvFilename
      a.click()
      window.URL.revokeObjectURL(blobURL)
    }

    return (
      <section>
        <header>
          <PageTitle>
            Reports by project type
            {loading && (
              <CircularLoader size={32} innerStyle={{ marginLeft: '15px' }} />
            )}
          </PageTitle>
        </header>

        <Card>
          <CardTitle
            title="Choose a project type and date range"
            subtitle="Note: this always takes a few seconds - be patient"
          />

          <CardText>
            <Row>
              <Col sm={12} md={3}>
                <ProjectTypeSelector
                  unselectedLabel="Project type (required)"
                  value={projectTypeId}
                  selectedIdCallback={this._setProjectType}
                  disabled={loading}
                  required
                  fullWidth
                />
              </Col>
              <Col sm={12} md={3}>
                <SimpleSelect
                  options={quoteStateOptions}
                  value={quoteState}
                  floatingLabelText="Quote state (required)"
                  onChange={this._setQuoteState}
                  disabled={loading}
                  required
                  fullWidth
                />
              </Col>
              <Col sm={12} md={3}>
                <DatePicker
                  fullWidth
                  hintText="Start date (optional)"
                  floatingLabelText="Start date"
                  defaultDate={dateToUTC()}
                  formatDate={date => formatDate(date)}
                  value={startDate}
                  onChange={this._setStartDate}
                  disabled={loading}
                />
              </Col>
              <Col sm={12} md={3}>
                <DatePicker
                  fullWidth
                  hintText="End date (optional)"
                  floatingLabelText="End date"
                  defaultDate={dateToUTC()}
                  formatDate={date => formatDate(date)}
                  value={endDate}
                  onChange={this._setEndDate}
                  disabled={loading}
                />
              </Col>
            </Row>
          </CardText>

          <CardActions style={{ textAlign: 'center' }}>
            <SaveButton
              type="submit"
              label="Generate CSV report"
              disabled={!enableGenerate}
              onTouchTap={this._generate}
            />
          </CardActions>
        </Card>

        <br />
        <BackButton disabled={loading} />

        <Dialog
          actions={doneDialogActions}
          modal={false}
          onRequestClose={this._closeDoneDialog}
          open={showDoneDialog}
        >
          <Card>
            <CardTitle title="CSV report generated!" />
            <CardText>
              <p>
                If your browser is configured to download files automatically,
                look for this file in your downloads folder:
              </p>
              <p>
                <strong>{csvFilename}</strong>
              </p>
            </CardText>
          </Card>
        </Dialog>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default ReportsByProjectType



// WEBPACK FOOTER //
// ./src/components/Reports/ReportsByProjectType.jsx